import { OfferResponse } from 'logic/api-models/api-models';

const isPayPerLead = (item?: OfferResponse) => !!item?.tutoringSchool?.websiteUrl;
export default isPayPerLead;
